<template>
  <div class="websiteproducts">
    <h1>Prodotti - {{ website.name }}</h1>
    <div v-if="this.$route.query.idProdotto > 0">
      <a :href="'https://www.fotocolombo.it/shop/admin/items/prodotto/edit.php?idProdotto='+this.$route.query.idProdotto+'&idProdottoCategoria=1'">Torna al backend</a><br>
    </div>
    <div v-if="products && products.length > 0" class="table-wrap">
      <div class="table-responsive">
          <table>
            <tr>
              <td width="">FID</td>
              <td width="">EAN</td>
              <td width="">Prodotto</td>
              <td width="">Prezzo</td>
              <td width="200" align="center">Azioni</td>
            </tr>
            <tr v-for="product in products" v-bind:key="product">
              <td>{{ product.sku }}</td>
              <td>{{ product.ean }}</td>
              <td>{{ product.name }}</td>
              <td>{{ product.price }}</td>
              <td align="center">
                  <router-link v-bind:to="{ name: 'ReportProductSku', params: { sku: product.sku } }">Report</router-link>
              </td>
            </tr>
          </table>
      </div>
    </div>
    <div v-else>
      Nessun prodotto per questo sito!<br /><br />
    </div>
    <div v-if="this.$route.query.idProdotto > 0">
      <a :href="'https://www.fotocolombo.it/shop/admin/items/prodotto/edit.php?idProdotto='+this.$route.query.idProdotto+'&idProdottoCategoria=1'">Torna al backend</a><br>
    </div>
  </div>
</template>

<script>
import WebsiteProductsService from '@/services/WebsiteProductsService'
export default {
  name: 'WebsiteProducts',
  data () {
    return {
        website: '',
        products: []
    }
  },
  mounted () {
    this.getWebsiteProducts()
  },
  methods: {
    async getWebsiteProducts (id) {
      const response = await WebsiteProductsService.get({id: this.$route.params.id})
      this.products = response.data.products
      this.website = response.data.website
    }
  }
}
</script>
<style type="text/css">
.table-wrap {
  /*width: 80%;
  margin: 0 auto;*/
  text-align: center;
}
table {
  width: 100%;
}
table th, table tr {
  text-align: left;
}
table thead {
  background: #f2f2f2;
}
table tr td {
  padding: 10px;
}
table tr:nth-child(odd) {
  background: #f2f2f2;
}
table tr:nth-child(1) {
  background: #4d7ef7;
  color: #fff;
}
a {
  color: #4d7ef7;
  text-decoration: none;
}
</style>



// WEBPACK FOOTER //
// src/components/WebsiteProducts.vue